import {DetailedProject} from "../../../api-client";

export const hasCollateralInfo = (project: DetailedProject): boolean => {
  const strategyContent = project.information?.strategyContent ?? [];

  return strategyContent.some(({text}) => text?.trim().length > 0);
};
